<template>

  <el-dialog title="忘记密码" :visible.sync="disvisible" customClass="unpdatepassword way" :append-to-body="true" :before-close="quxiao">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" class="demo-dynamic" @keyup.enter.native="dataFormSubmit()" label-width="80px">
      <el-form-item label="账号" prop="account">
        <el-input type="text" v-model="dataForm.account"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="tel">
        <el-input type="text" v-model="dataForm.tel"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="note">
        <el-input type="text" v-model="dataForm.note" style="width:205px"></el-input>
        <el-button type="success" size="medium" style="margin-left:10px" @click="SendCode()" :disabled="fsyzmif">{{ fsyzm }}</el-button>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
        <el-input type="password" v-model="dataForm.newPwd"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input type="password" v-model="dataForm.confirmPassword"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="quxiao">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    disvisible: {
      type: Boolean,
    },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (this.dataForm.newPwd !== value) {
        callback(new Error("确认密码与新密码不一致"));
      } else {
        callback();
      }
    };
    return {
      dataForm: {
        account: "",
        tel: "",
        note: "",
        newPwd: "",
        confirmPassword: "",
      },
      fsyzm: "发送验证码",
      // 倒计时
      countdown: 60,
      // 不能重复点击
      fsyzmif: false,
      dataRule: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        tel: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        note: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
        newPwd: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  created() {},

  methods: {
    // 初始化
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    //发送验证码
    SendCode() {
      var tel = this.dataForm.tel;
      if (!tel) {
        this.$message.error("请输入手机号码");
        return;
      } else {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SendCode",
          data: { ctelphone: tel },
        }).then((res) => {
          console.log(res);
          if (res.data.Code == "1") {
            var sert = setInterval(() => {
              if (this.countdown == 0) {
                this.fsyzmif = false;
                this.fsyzm = "获取验证码";
                this.countdown = 60;
                clearInterval(sert);
                return;
              } else {
                this.fsyzmif = true;
                this.fsyzm = "重新发送(" + this.countdown + ")";
                this.countdown--;
              }
            }, 1000);
            this.$message.success(res.data.Message);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/LoginAccountCheck ",
            data: {
              account: this.dataForm.account,
              tel: this.dataForm.tel,
              note: this.dataForm.note,
              newPwd: this.dataForm.newPwd,
            },
          }).then((res) => {
            console.log(res);
            if (res.data.Success) {
              // this.$message.success(res.data.Message);
              this.forpwd(res.data.Data.account);
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      });
    },
    forpwd(account) {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/ForgetPwdByTel",
        data: {
          account: account,
          tel: this.dataForm.tel,
          note: this.dataForm.note,
          newPwd: this.dataForm.newPwd,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.$message.success(res.data.Message);
          this.$emit("fgtpaw", false);
          window.location.reload();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    quxiao() {
      this.$emit("fgtpaw", false);
    },
  },
};
</script>

